import endpoints from "../utils/endpoints";
import { Api } from "./api";
import { notificationError } from "./notification";

export async function getHeaderItems() {
    let res = [{
        key: '',
        name: '',
        link: '',
        childs: null,
    }];
    await Api.get(endpoints.getMenu).then((response) => {
      res = response.data
    }).catch((err: string) => {
      notificationError('Could not get data from servers')
    })

    if(!res || res.length === 0) {
      let res = [{
        image: "",
        name: "",
        portal: "",
        message: "",
        version: "",
        return: false
      }];
      await Api.get(endpoints.getFooter).then((response) => {
        if(!response || response.data.return === false) {
          localStorage.removeItem('user');
          if(window.location.pathname !== '/logoff' && window.location.pathname !== '/') window.location.href = '/' 
        }
      }).catch((err: string) => {
        localStorage.removeItem('user');
        if(window.location.pathname !== '/logoff' && window.location.pathname !== '/') window.location.href = '/' 
      })

    }
    
    return res
}